
import { request } from "../network/request";
const db = "dn0";


export function getProgramModelList(params) {
    return request({
        url: "pmp/program/loadProgramModelList",
        method: "get",
        params,
    });
}

export function getProjectsList(params) {
    return request({
        url: "pmp/program/listProjects",
        method: "get",
        params,
    });
}

export function getProgramCount(params) {
    return request({
        url: "pmp/program/getProgramCount",
        method: "get",
        params,
    });
}

export function loadKeepTouchUser(params) {
    return request({
        url: "pmp/program/loadKeepTouchUser",
        method: "get",
        params,
    });
}


export function insertProgram(params) {
    return request({
        url: "pmp/program/insertProgram",
        method: "post",
        data: params,
    });
}